import { useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth';
import { ClienteForm, VAZIO } from './ClienteForm';

export function ClienteNovoPage() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { me } = useAuth();
  return (
    <>
      <Link to="/clientes" className="small">← Clientes</Link>
      <h1>Novo cliente</h1>
      <ClienteForm
        inicial={{ ...VAZIO, vendedorId: me?.usuario.id ?? '' }}
        onCancelar={() => nav('/clientes')}
        onSalvar={async (payload) => {
          const r = await api<{ cliente: { id: string } }>('/clientes', { body: payload });
          await qc.invalidateQueries({ queryKey: ['clientes'] });
          nav(`/clientes/${r.cliente.id}`, { replace: true });
        }}
      />
    </>
  );
}
